import React from 'react';
import JewelThree from '../../assets/images/jewel_three.jpg';

// Light jewellery photo shown over the red panel; styled in modules/SignIn/index.scss.
const JewelBackdrop: React.FC = () => (
  <div className="jewel-bg" aria-hidden="true">
    <img src={JewelThree} alt="" />
  </div>
);

export default JewelBackdrop;
